import axios from 'axios';

export async function search(
  filters: Record<string, unknown>
): Promise<App.Configuration.Data.ProgramData[]> {
  return axios.get(route('api.programs.search', filters)).then((res) => res.data);
}
